/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "eu-west-2",
    "aws_cognito_identity_pool_id": "eu-west-2:6d07473f-a06f-403c-a1f4-9c77c04415e8",
    "aws_cognito_region": "eu-west-2",
    "aws_user_pools_id": "eu-west-2_QzXAsveoH",
    "aws_user_pools_web_client_id": "5u4dg4ldiqh1ruvmp7vok761as",
    "oauth": {},
    "aws_cognito_username_attributes": [
        "EMAIL"
    ],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL",
        "NAME"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "PHONE_NUMBER"
    ],
    "geo": {
        "amazon_location_service": {
            "region": "eu-west-1",
            "maps": {
                "items": {
                    "amnLocationServed-dev": {
                        "style": "VectorOpenDataStandardDark"
                    }
                },
                "default": "amnLocationServed-dev"
            }
        }
    }
};


export default awsmobile;
